/**
 * Message Layout Theme Constants
 * Design tokens for message layout components following industry standards
 * (WhatsApp, Telegram, Slack, Discord)
 */

export const messageLayoutTokens = {
  avatar: {
    size: {
      small: 16, // Compact mode
      medium: 18, // Standard (comfortable mode)
      large: 18 // Emphasis
    }
  },
  spacing: {
    groupedMessages: 2, // Same sender grouped
    ungroupedMessages: 8, // Different sender
    timeGapSeparator: 16 // >threshold gap
  },
  borderRadius: {
    default: 16,
    grouped: 4
  },
  timestamp: {
    fontSize: 10,
    opacity: 0.7,
    hoverDelay: 500 // ms before tooltip appears
  },
  padding: {
    small: 8,
    medium: 12,
    large: 16
  },
  fontSize: {
    header: 12,
    timestamp: 10,
    content: 14
  },
  opacity: {
    timestamp: 0.7,
    disabled: 0.6,
    hover: 0.8
  },
  transition: {
    duration: 200, // ms
    easing: 'ease-out'
  }
} as const;

/** Avatar size options */
export type AvatarSize = keyof typeof messageLayoutTokens.avatar.size;

/** Timestamp display strategy */
export type TimestampStrategy = 'inline' | 'hover' | 'grouped';

/** Message density mode */
export type MessageDensity = 'compact' | 'comfortable';
